import * as Types from './bugReportsActionTypes';

export function submitBugReport(data, onSuccess, onFail) {
  return { type: Types.SUBMIT_BUG_REPORT, data, onSuccess, onFail };
}

export function submitBugReportSuccess(data) {
  return { type: Types.SUBMIT_BUG_REPORT_SUCCESS, data };
}

export function submitBugReportFailure(error) {
  return { type: Types.SUBMIT_BUG_REPORT_FAILURE, error };
}

export function getBugReports() {
  return { type: Types.GET_BUG_REPORTS };
}

export function getBugReportsSuccess(data) {
  return { type: Types.GET_BUG_REPORTS_SUCCESS, data };
}

export function getBugReportsFailure(error) {
  return { type: Types.GET_BUG_REPORTS_FAILURE, error };
}

export function updateBugReport(data, onSuccess, onFail) {
  return { type: Types.UPDATE_BUG_REPORT, data, onSuccess, onFail };
}

export function updateBugReportSuccess(data) {
  return { type: Types.UPDATE_BUG_REPORT_SUCCESS, data };
}

export function updateBugReportFailure(error) {
  return { type: Types.UPDATE_BUG_REPORT_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/redux/actions/bugReportsActions.js